window.customFreeShippingBar = (function() {
  'use strict';

  let barElement = null;
  let messageElement = null;
  let config = {};

  const DEFAULT_SETTINGS = {
    threshold: 99.00,
    currencySymbol: '$',
    initialShippingCost: 5.90,
    barLinkUrl: 'https://lashpro.nz/pages/shipping', 
    // Message templates
    messageInitial: '[symbol][cost] Overnight NZ Shipping, <span class="fsb-mobile-break"></span><span class="fsb-highlight">FREE</span> on Orders Over <span class="fsb-highlight">[threshold_formatted]</span>',
    messageAway: 'Only <span class="fsb-highlight">[amount_needed]</span> away from <span class="fsb-mobile-break"></span><span class="fsb-highlight">FREE</span> Overnight Shipping!',
    // Array of achieved messages
    achievedMessages: [
      'Nice one! You’ve scored <span class="fsb-mobile-break"></span><span class="fsb-highlight">FREE</span> overnight shipping.',
      'Woohoo! <span class="fsb-highlight">FREE</span> overnight shipping is all yours.',
      'You’ve got <span class="fsb-highlight">FREE</span> overnight shipping – lucky you!',
      'Boom! You just unlocked <span class="fsb-mobile-break"></span><span class="fsb-highlight">FREE</span> overnight shipping.',
      'Yesss! You\'re getting <span class="fsb-highlight">FREE</span> <span class="fsb-mobile-break"></span>overnight shipping on your order.'
    ]
  };

  // CSS Styles to be injected
  const STYLES = `
    #custom-free-shipping-bar {
      display: block; /* Make it a block element for the <a> tag */
      text-decoration: none; /* Remove underline from link */
      background-color: rgb(38, 38, 32); /* #262620 */
      color: rgb(255, 255, 255);       /* #FFFFFF */
      text-align: center;
      width: 100%;
      padding: 12px 15px;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 16px;
      line-height: 1.4;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 1000000;
      box-sizing: border-box;
      transition: opacity 0.3s ease, transform 0.3s ease;
      transform: translateY(100%);
      opacity: 0;
      cursor: pointer; /* Add pointer cursor for the link */
    }
    #custom-free-shipping-bar.fsb-visible {
      transform: translateY(0);
      opacity: 1;
    }
    #custom-fsb-message-container {
      display: inline-block;
      /* Ensure text color is inherited if <a> tag tries to override */
      color: inherit;
    }
    .fsb-highlight {
      color: rgb(234, 153, 151); /* #EA9997 */
      font-weight: bold;
    }
    .fsb-mobile-break {
      display: none; /* Hidden by default */
    }

    /* Apply line break for mobile - Adjust max-width as needed */
    @media (max-width: 768px) {
      .fsb-mobile-break { /* Targeting the span directly, not ::before */
        display: block; 
        height: 0;      
        width: 100%;    
        content: "";    /* Optional, but can help ensure layout */
      }
    }
  `;

  function formatCurrency(amount, symbol, showCents = true) {
    if (typeof amount !== 'number') {
        amount = parseFloat(amount);
    }
    if (isNaN(amount)) {
        return '';
    }
    if (showCents) {
        return symbol + amount.toFixed(2);
    } else {
        // Check if it's a whole number, if so, don't show .00
        return symbol + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));
    }
  }

  function createBarHtml() {
    if (document.getElementById('custom-free-shipping-bar')) {
      barElement = document.getElementById('custom-free-shipping-bar');
      messageElement = document.getElementById('custom-fsb-message-container');
      if (config.barLinkUrl) { // Update href if already exists and config is now loaded
        barElement.href = config.barLinkUrl;
      }
      return;
    }

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.id = "custom-fsb-styles";
    styleSheet.innerText = STYLES;
    document.head.appendChild(styleSheet);

    // Change barElement to an <a> tag
    barElement = document.createElement('a');
    barElement.id = 'custom-free-shipping-bar';
    if (config.barLinkUrl) {
        barElement.href = config.barLinkUrl;
        // Optional: Open in new tab
        // barElement.target = "_blank";
        // barElement.rel = "noopener noreferrer";
    }


    messageElement = document.createElement('div');
    messageElement.id = 'custom-fsb-message-container';

    barElement.appendChild(messageElement);
    document.body.appendChild(barElement);
  }

  function getRandomAchievedMessage() {
    if (!config.achievedMessages || config.achievedMessages.length === 0) {
      return 'Congrats! You\'ve got <span class="fsb-highlight">FREE</span> Overnight Shipping!'; // Fallback
    }
    const randomIndex = Math.floor(Math.random() * config.achievedMessages.length);
    return config.achievedMessages[randomIndex];
  }

  function updateDisplay(cartDataFromTheme) {
    if (!barElement || !messageElement) {
      // If init hasn't run yet (e.g. DOMContentLoaded not fired, but updateDisplay called early)
      // we need to ensure createBarHtml is called once config is available.
      // This is a bit of a safeguard. The primary call is in init.
      if (Object.keys(config).length > 0) createBarHtml();
      else {
        console.warn('Free Shipping Bar not initialized or config not loaded.');
        return;
      }
    }
     // Ensure barElement is up-to-date, especially if createBarHtml was called after init
    if (!barElement) barElement = document.getElementById('custom-free-shipping-bar');
    if (!messageElement && barElement) messageElement = document.getElementById('custom-fsb-message-container');
    if (!barElement || !messageElement) return; // Still not ready


    const processCartData = (cart) => {
      const itemCount = cart.item_count;
      const totalPriceInCents = cart.total_price;
      const thresholdInCents = config.threshold * 100;

      let message = '';
      const formattedThreshold = formatCurrency(config.threshold, config.currencySymbol, false); // No cents for threshold

      if (itemCount === 0) {
        message = config.messageInitial
          .replace('[symbol]', config.currencySymbol)
          .replace('[cost]', config.initialShippingCost.toFixed(2))
          .replace('[symbol]', config.currencySymbol) // Second symbol for threshold
          .replace('[threshold_formatted]', formattedThreshold); // Use formatted threshold
      } else if (totalPriceInCents < thresholdInCents) {
        const amountNeeded = (thresholdInCents - totalPriceInCents) / 100;
        message = config.messageAway
          .replace('[symbol]', config.currencySymbol)
          .replace('[amount_needed]', formatCurrency(amountNeeded, config.currencySymbol, true)); // Show cents for amount_needed
      } else {
        message = getRandomAchievedMessage(); // Get a random achieved message
      }

      messageElement.innerHTML = message;
      barElement.classList.add('fsb-visible');
    };

    if (cartDataFromTheme) {
      processCartData(cartDataFromTheme);
    } else {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          processCartData(cart);
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
          const formattedThreshold = formatCurrency(config.threshold, config.currencySymbol, false);
          messageElement.innerHTML = config.messageInitial
            .replace('[symbol]', config.currencySymbol)
            .replace('[cost]', config.initialShippingCost.toFixed(2))
            .replace('[symbol]', config.currencySymbol)
            .replace('[threshold_formatted]', formattedThreshold);
          barElement.classList.add('fsb-visible');
        });
    }
  }

  function init(userSettings = {}) {
    config = { ...DEFAULT_SETTINGS, ...userSettings };
    config.threshold = parseFloat(config.threshold);
    config.initialShippingCost = parseFloat(config.initialShippingCost);
    // Optional: Make barLinkUrl a theme setting if desired
    // config.barLinkUrl = userSettings.barLinkUrl || DEFAULT_SETTINGS.barLinkUrl;


    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            createBarHtml(); // Create HTML structure
            updateDisplay();   // Initial update
        });
    } else {
        createBarHtml(); // Create HTML structure
        updateDisplay();   // Initial update
    }
  }

  return {
    init: init,
    updateDisplay: updateDisplay
  };
})();